import { createSlice } from '@reduxjs/toolkit';
import appTypes from '../app/types';
import { mapPricingPlan } from './mappers';
const initialState = {
    isLoaded: false,
    isLoading: false,
    loadErrorMessage: null,
    pricingVersion: null,
    experienceMode: null,
    experimentVariant: null,
    hierarchyStep: null,
    isCrossVersionUser: false,
    plans: [],
    seatProducts: [],
    pricingPlanFeatures: null,
};
const slice = createSlice({
    name: 'PRICING',
    initialState,
    extraReducers(builder) {
        builder.addCase(appTypes.RESET, () => initialState);
    },
    reducers: {
        fetchStarted(state) {
            state.isLoading = true;
            state.loadErrorMessage = null;
        },
        fetchSucceeded(state, { payload }) {
            state.pricingVersion = (payload === null || payload === void 0 ? void 0 : payload.pricing_version) || null;
            state.experienceMode = (payload === null || payload === void 0 ? void 0 : payload.experience_mode) || null;
            state.experimentVariant = (payload === null || payload === void 0 ? void 0 : payload.experiment_variant) || null;
            state.hierarchyStep = (payload === null || payload === void 0 ? void 0 : payload.hierarchy_step) || null;
            state.isCrossVersionUser = (payload === null || payload === void 0 ? void 0 : payload.is_cross_version_user) || false;
            state.plans = ((payload === null || payload === void 0 ? void 0 : payload.plans) || []).map(mapPricingPlan);
            state.seatProducts = (payload === null || payload === void 0 ? void 0 : payload.seatProducts) || [];
            state.pricingPlanFeatures = (payload === null || payload === void 0 ? void 0 : payload.pricingPlanFeatures) || null;
            state.isLoaded = true;
            state.isLoading = false;
        },
        fetchFailed(state, { payload }) {
            state.isLoaded = false;
            state.isLoading = false;
            state.loadErrorMessage = payload;
        },
    },
});
export const { reducer, actions } = slice;
export default reducer;
